import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService } from '../app.service';
import { StudiosHttpClientService } from '../shared/services/studios-http-client.service';
import { UtilitiesService } from '../shared/services/utilities.service';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  readonly #appService = inject(AppService);
  readonly #httpClient = inject(HttpClient);
  private baseUrl: string = this.#appService.utilsUrls.apiUrl;

  public getShootingList(orderId: number, loaderId?: string): Observable<Blob> {
    const url = this.baseUrl + '/Photographer/GetShootingList';
    return this.#httpClient.get(url, {
      params: { orderId: orderId.toString() },
      responseType: 'blob',
    });
  }

}
